
import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, MessageCircle, Share } from "lucide-react";
import { ColorFeedback, EnhancedColorResult } from "@/hooks/color-check/types";

interface ResultFooterProps {
  colorResult: EnhancedColorResult;
  hasInventoryMatches: boolean;
  hasExactColorMatches: boolean;
  hasExactSizeMatches: boolean;
  onSendExternalRequest: () => void;
  onProvideFeedback: (feedback: ColorFeedback) => void;
}

const ResultFooter = ({ 
  colorResult, 
  hasInventoryMatches, 
  hasExactColorMatches, 
  hasExactSizeMatches,
  onSendExternalRequest,
  onProvideFeedback 
}: ResultFooterProps) => {
  return (
    <>
      {!hasInventoryMatches && (
        <Button className="w-full" onClick={onSendExternalRequest}>
          <MessageCircle className="mr-2 h-4 w-4" />
          Stuur externe aanvraag
        </Button>
      )}
      
      <div className="flex gap-2 w-full">
        <Button 
          variant="outline" 
          className="flex-1"
          onClick={() => onProvideFeedback({
            analysisId: colorResult.analysisId,
            feedbackType: 'correct',
            notes: hasExactColorMatches && hasExactSizeMatches ? 'Perfecte match bevestigd' : 
                   hasExactColorMatches ? 'Kleur match bevestigd' : 'Analyse correct bevestigd'
          })}
        >
          <CheckCircle className="mr-1 h-3 w-3" />
          Correct
        </Button>
        <Button 
          variant="outline" 
          className="flex-1"
          onClick={() => onProvideFeedback({
            analysisId: colorResult.analysisId,
            feedbackType: 'incorrect',
            sizeIssue: !hasExactSizeMatches,
            correctSize: colorResult.parsedInfo.size,
            notes: hasExactColorMatches ? 'Maat probleem' : 'Kleur probleem - verkeerde kleur gevonden'
          })}
        >
          Incorrect
        </Button>
        <Button variant="outline">
          <Share className="h-3 w-3" />
        </Button>
      </div>
    </>
  );
};

export default ResultFooter;
